module.exports = __webpack_public_path__ + "img/success-flag.3b69dfe8.svg";